import { MODEL_PREVIEW_URL } from "./env.const";

/** Base URL of the model-preview app (local GLB test + catalog viewer). */
export const MODEL_PREVIEW_APP_BASE = MODEL_PREVIEW_URL.replace(/\/$/, "");
